export default "__VITE_ASSET__DXu0cW5K__"